import { render, staticRenderFns } from "./HelperMessage.vue?vue&type=template&id=3600f964&"
import script from "./HelperMessage.vue?vue&type=script&lang=js&"
export * from "./HelperMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports